module.exports = __webpack_public_path__ + "static/media/minjae-kim.56c0eabe.jpeg";